var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('van-nav-bar',{attrs:{"title":"我的","fixed":""}}),_c('h1',[_vm._v("Profile")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }